import { createStructuredSelector } from 'reselect';

import { fetchRAGState } from '../../RecommendGrant/Selectors/RecommendGrantPageSelectors';

export const selectRAGPurpose = (state) => {
  const { purpose } = fetchRAGState(state);
  return purpose;
};

export const selectProject = (state) => {
  const { project } = fetchRAGState(state);
  return project;
};

export const selectEventName = (state) => {
  const { eventName } = fetchRAGState(state);
  return eventName;
};

export const selectMissionaryNames = (state) => {
  const { missionaryNames } = fetchRAGState(state);
  return missionaryNames;
};

export const selectMissionaryLocations = (state) => {
  const { missionaryLocations } = fetchRAGState(state);
  return missionaryLocations;
};

export const paymentLetterDerivedStates = createStructuredSelector({
  purpose: selectRAGPurpose,
  project: selectProject,
  event: selectEventName,
  missionaryName: selectMissionaryNames,
  missionaryLocation: selectMissionaryLocations,
});
